// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"NrlZeBQk","description":"IVu6dZW0","chipsWrapper":"ChvLwEHv","warningText":"fo5CkOgc","inputWrapper":"WkKcRX2f","chatInputComposerWrapper":"cYjfQ1AK"};